import { Link } from 'react-router-dom'
import logoIcon from '../../assets/logo-icon.png'

export default function AuthBrand() {
  return (
    <Link to="/" className="flex justify-center mb-6 group">
      <div className="flex items-center space-x-2.5 transition-transform group-hover:scale-105">
        <img src={logoIcon} alt="Ofertator" className="h-10 w-10 object-contain flex-shrink-0" />
        <span className="text-2xl font-bold text-white tracking-tight font-switzer">Ofertator</span>
      </div>
    </Link>
  )
}
